// Initialize the Intiaro configurator
async function initIntiaro() {
  const { viewer, controller } = await IntiaroConfigurator.create(
    "html-player-id"
  );

  // viewer and controller are now available so you could do something like this to listen for configuration changes
  viewer.registerListener("configurationChanged", (data) =>
    console.log("configurationChanged", data)
  );
}

/**
 * Creates an object for managing a brand's Intiaro configurator.
 *
 * @param {string} customerId - The Intiaro customer ID for the brand.
 * @param {string} productId - The ID of the product.
 * @returns {Object} An object with methods for checking the configurator's availability and initializing it.
 */
function intiaroConfigurator(customerId, productId) {
  return {
    available: false,
    showConfigurator: false,
    intiatroInitialized: false,

    init() {
      this.checkAvailability(productId);
    },

    // Check if the configurator is available for the product
    checkAvailability: function (productId) {
      const apiUrl = `https://public-api.intiaro.com/app/${encodeURIComponent(customerId)}/sku/${encodeURIComponent(productId)}`;

      fetch(apiUrl)
        .then((response) => response.json())
        .then((data) => (this.available = data.available ? true : false))
        .catch((error) => {
          console.error("Error:", error);
          this.available = false;
        });
    },

    hideConfigurator() {
      this.showConfigurator = false;
    },

    // Get the configurator for the product
    getIntiaroConfigurator() {
      if (this.available) {
        this.showConfigurator = true;

        if (!this.intiatroInitialized) {
          const intiaroWrapper = document.querySelector(".intiaro-wrapper");
          intiaroWrapper.addEventListener("click", (e) => {
            if (e.target.parentNode === document.body) {
              this.showConfigurator = false;
            }
          });

          initIntiaro();
          this.intiatroInitialized = true;
        }
      }
    },
  };
}

